module.exports = __webpack_public_path__ + "static/media/timelapse_7.6b627675.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_7.jpg
// module id = 967
// module chunks = 0